import React from 'react';
import Layout from "../components/Layout";
import { EstructuraAgentesCobranza } from '../components';


const EstructuraAgentesCobranzaPage = () => {
    return (
        <>
            <Layout />
            <div>
                <EstructuraAgentesCobranza />
            </div>
        </>
    );
}

export default EstructuraAgentesCobranzaPage;